import React from 'react';
import type { PodletKey, PodletResponse } from '../../server';

export type EmbeddedPodletKey = Extract<
    PodletKey,
    'polePosition' | 'sortingInfo'
>;
export type EmbeddedPodletResponse = Pick<PodletResponse, 'content' | 'js'>;
export type EmbeddedPodlets = Record<EmbeddedPodletKey, EmbeddedPodletResponse>;

const PodletsContext = React.createContext<EmbeddedPodlets | undefined>(void 0);

type PodletsProviderProps = {
    children: React.ReactNode;
    podlets: EmbeddedPodlets;
};

export function PodletsProvider(props: PodletsProviderProps) {
    const { children, podlets } = props;

    return (
        <PodletsContext.Provider value={podlets}>
            {children}
        </PodletsContext.Provider>
    );
}

export function usePodlets() {
    const context = React.useContext(PodletsContext);
    if (typeof context === 'undefined') {
        throw new Error('usePodlets must be used within an PodletsProvider');
    }
    return context;
}
